export default __webpack_public_path__ + "static/piechart-7a68ba473e7634e22b8307d380309bfc.png";